import { Component, ElementRef, Input, Optional, Self } from '@angular/core';
import { ControlValueAccessor, NgControl } from '@angular/forms';
import { AbstractControlValueAccessorComponent } from '../../abstracts/abstract-control-value-accessor.component';
import { FormUtil } from '../../utils';

@Component({
    selector: 'px-checkbox',
    templateUrl: './checkbox.component.html',
})
export class CheckboxComponent extends AbstractControlValueAccessorComponent implements ControlValueAccessor {
    @Input() title: string;
    @Input() disabled: boolean;

    constructor(@Optional() @Self() public ngControl: NgControl, public elementRef: ElementRef) {
        super();
        if (this.ngControl != null) {
            this.ngControl.valueAccessor = this;
        }
    }

    get value(): string {
        return this.innerValue;
    }

    set value(value: string) {
        if (value !== this.innerValue) {
            this.writeValue(value);
        }
    }

    get formControl() {
        return this.ngControl ? this.ngControl.control : null;
    }

    get hasError() {
        return this.formControl && this.formControl.errors;
    }

    get hasErrorAndIsTouched() {
        return this.hasError && this.formControl.touched;
    }

    get isRequired() {
        return this.formControl && FormUtil.hasValidatorKey(this.formControl, 'required');
    }

    get errorMessage() {
        return FormUtil.getFirstError(this.formControl);
    }
}
